<div class="item-fee">
    <div
        class="fee-label"
        [class]="'mb-0 me-1 ds-fee-style' + (fontClassLabel ? ' ' + fontClassLabel : ' title foreground-disabled-text')"
        [ngClass]="{
            bold: labelBold,
            'title-small': size === 'small' && !fontClassLabel,
            'title-medium': size === 'medium' && !fontClassLabel,
            'title-large': size === 'large' && !fontClassLabel,
        }"
    >
        {{ feeLabel }}
        @if (!!tooltipInformation) {
            <mat-icon class="md-icon-16 tooltip-info ms-1" [matTooltip]="tooltipInformation" matTooltipPosition="after">
                info
            </mat-icon>
        }
        @if (tooltipInformationHTML && !tooltipInformation) {
            <div class="container-fee">
                <mat-icon class="md-icon-16 ms-1"> info </mat-icon>
                <div class="container-fee-information" [innerHtml]="tooltipInformationHTML | sanitize: 'html'"></div>
            </div>
        }
    </div>
    <span
        class="fee-value text-end"
        [class]="'value item-fee-value mb-0 ds-fee-style' + (fontClassValue ? ' ' + fontClassValue : '')"
        [ngClass]="{
            bold: valueBold,
            'value-small': size === 'small' && !fontClassValue,
            'value-medium': size === 'medium' && !fontClassValue,
            'value-large': size === 'large' && !fontClassValue,
        }"
    >
        {{ feeValue | currency }}
    </span>
</div>
